export enum ESignupForms {
  welcomePage = 'welcomePage',
  signupForm = 'signupForm',
  successPage = 'successPage',
  last = 'last',
}
